<div >
  <div>
    <p-card header="Вход в систему" class="flex items-center justify-center p-4 cntr">
      <div class="w-full">
        <form (ngSubmit)="onLogin(form)" #form="ngForm" class="space-y-4">
          <div class="flex-wrap">
            <label class="lbl" for="lgn">Логин</label>
            <input pInputText type="text" id="lgn" name="login" placeholder="Введите логин" ngModel class="w-full"/>
          </div>
          <div class="flex-wrap"> 
            <label class="lbl" for="passwd">Пароль</label>
            <p-password [toggleMask]="true" [feedback]="false" inputId="passwd" name="passwd" placeholder="Введите пароль" ngModel class="w-full"></p-password>
          </div>
          <div class="flex w-full justify-center">
            <p-button pRipple label="Вход" type="submit" ></p-button>
          </div>
        </form>

        @if(!cargoFeatures?.isNewUserAdminRequired){
        <div class="flex justify-center flex-wrap">
          <p class="pt-6">
            Нет учётной записи? <a class="underline underline-offset-4 decoration-pink-500" routerLink="/register">Регистрация</a>
          </p>
        </div>
        }
      </div>


    </p-card>
  </div>
</div>

